import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-layout-half",
  "use": "svg-icon-layout-half-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"svg-icon-layout-half\"><path d=\"M10.001 16.805h-3.93c-.67 0-1.213-.542-1.213-1.212V6.869c0-.669.543-1.212 1.213-1.212h3.93v11.148m1.714-11.148h3.931c.67 0 1.212.543 1.212 1.212v8.724c0 .67-.542 1.212-1.212 1.212h-3.931V5.657\" fill=\"#CAD4D8\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol